export { default as BulletinDetailScreen } from "./BulletinDetailScreen";
